<!-- @format -->

<skills>
  <style>
    ul.checkbox_list {
      display: flex;
      flex-wrap: wrap;
    }
  </style>

  <div class="container_accordion">
    <div class="accordion_heading is-hide" data-group="media">
      <div class="checkbox_wrap">
        <input
          type="checkbox"
          id="media_all"
          class="checkbox-input"
          onclick="{ onCheckMediaAll }"
        />
        <label for="media_all" class="checkbox-parts">
          編集・執筆したことがある媒体
        </label>
      </div>
      <div class="js-accordion"></div>
    </div>
    <!--/.accordion_heading-->

    <div class="accordion_body" data-group="media" style="display: none">
      <template each="{ (mediaType, index) in props.master.media }">
        <div
          class="accordion_heading02 { index ? 'margin-spacing-4_top' : '' }"
        >
          <div class="checkbox_wrap">
            <input
              class="checkbox-input"
              type="checkbox"
              id="media_type_id_{mediaType.id}"
              value="{ mediaType.id }"
              onclick="{ e => onCheckMediaType(e, mediaType.id) }"
            />
            <label for="media_type_id_{mediaType.id}" class="checkbox-parts">
              { mediaType.jname }
            </label>
          </div>
        </div>
        <!--/.accordion_heading02-->

        <template each="{ detail in mediaType.list }">
          <h4 class="heading-04 margin-spacing-2_top">{ detail.jname }</h4>

          <ul class="checkbox_list margin-spacing-1_top">
            <li
              class="checkbox_list-item"
              each="{ media in detail.list }"
              if="{ media.type=='check' }"
            >
              <input
                class="checkbox-input media-publication"
                type="checkbox"
                checked="{ props.data.media.isChecked(media.id) }"
                id="media_id_{ media.id }"
                value="{ media.id }"
                onclick="{ e => onCheckMedia(e, media.id) }"
              />
              <label for="media_id_{ media.id }" class="checkbox-parts">
                { media.jname }
              </label>
            </li>
          </ul>

          <template each="{ media in detail.list }" if="{ media.type=='text' }">
            <ul class="checkbox_list margin-spacing-1_top">
              <li class="checkbox_list-item">
                <input
                  class="checkbox-input js-check_skill-other"
                  type="checkbox"
                  checked="{ props.data.media.isChecked(media.id) }"
                  id="media_id_{ media.id }"
                  value="{ media.id }"
                  onclick="{ e => onCheckMedia(e, media.id) }"
                />
                <label for="media_id_{ media.id }" class="checkbox-parts">
                  { media.jname }
                </label>
              </li>
            </ul>
            <div class="box_w50">
              <input
                class="text_input input_skill-other"
                type="text"
                value="{ props.data.media.getMemo(media.id) }"
                disabled="{ !props.data.media.isChecked(media.id) }"
                oninput="{ e => onTextMedia(e, media.id) }"
              />
            </div>
            <div if="{ getError('media', media.id) }" class="error">
              { getError('media', media.id) }
            </div>
          </template>
        </template>
      </template>
    </div>
    <!--/.accordion_body-->
  </div>
  <!--/.container_accordion-->

  <div class="container_accordion">
    <div class="accordion_heading is-hide" data-group="contents">
      <div class="checkbox_wrap">
        <input
          type="checkbox"
          id="contents_all"
          class="checkbox-input"
          onclick="{ onCheckContentsAll }"
        />
        <label for="contents_all" class="checkbox-parts">
          編集・執筆したことがあるコンテンツ・記事
        </label>
      </div>
      <div class="js-accordion"></div>
    </div>
    <!--/.accordion_heading-->

    <div class="accordion_body" data-group="contents" style="display: none">
      <template each="{ (contentsType, index) in props.master.contents }">
        <!--/.accordion_heading02-->

        <h4 class="heading-04 margin-spacing-2_top">{ contentsType.jname }</h4>

        <ul class="checkbox_list margin-spacing-1_top">
          <li
            class="checkbox_list-item"
            each="{ contents in contentsType.list }"
            if="{ contents.type=='check' }"
          >
            <input
              class="checkbox-input media-publication"
              type="checkbox"
              checked="{ props.data.contents.isChecked(contents.id) }"
              id="contents_id_{ contents.id }"
              value="{ contents.id }"
              onclick="{ e => onCheckContents(e, contents.id) }"
            />
            <label for="contents_id_{ contents.id }" class="checkbox-parts">
              { contents.jname }
            </label>
          </li>
        </ul>

        <template
          each="{ contents in contentsType.list }"
          if="{ contents.type=='text' }"
        >
          <ul class="checkbox_list margin-spacing-1_top">
            <li class="checkbox_list-item">
              <input
                class="checkbox-input js-check_skill-other"
                type="checkbox"
                checked="{ props.data.contents.isChecked(contents.id) }"
                id="contents_id_{ contents.id }"
                value="{ contents.id }"
                onclick="{ e => onCheckContents(e, contents.id) }"
              />
              <label for="contents_id_{ contents.id }" class="checkbox-parts">
                { contents.jname }
              </label>
            </li>
          </ul>
          <div class="box_w50">
            <input
              class="text_input input_skill-other"
              type="text"
              value="{ props.data.contents.getMemo(contents.id) }"
              disabled="{ !props.data.contents.isChecked(contents.id) }"
              oninput="{ e => onTextContents(e, contents.id) }"
            />
          </div>
          <div if="{ getError('contents', contents.id) }" class="error">
            { getError('contents', contents.id) }
          </div>
        </template>
      </template>
    </div>
    <!--/.accordion_body-->
  </div>
  <!--/.container_accordion-->

  <div class="container_accordion">
    <div class="accordion_heading is-hide" data-group="skill">
      <div class="checkbox_wrap">
        <input
          type="checkbox"
          id="skill_all"
          class="checkbox-input"
          onclick="{ onCheckSkillAll }"
        />
        <label for="skill_all" class="checkbox-parts">
          編集・執筆関連スキル
        </label>
      </div>
      <div class="js-accordion"></div>
    </div>
    <!--/.accordion_heading-->

    <div class="accordion_body" data-group="skill" style="display: none">
      <template each="{ (genre, index) in props.master.skill }">
        <!--/.accordion_heading02-->

        <h4 class="heading-04 margin-spacing-2_top">{ genre.jname }</h4>

        <ul class="checkbox_list margin-spacing-1_top">
          <li
            class="checkbox_list-item"
            each="{ skill in genre.list }"
            if="{ skill.type=='check' }"
          >
            <input
              class="checkbox-input media-publication"
              type="checkbox"
              checked="{ props.data.skill.isChecked(skill.id) }"
              id="skill_id_{ skill.id }"
              value="{ skill.id }"
              onclick="{ e => onCheckSkill(e, skill.id) }"
            />
            <label for="skill_id_{ skill.id }" class="checkbox-parts">
              { skill.jname }
            </label>
          </li>
        </ul>

        <template each="{ skill in genre.list }" if="{ skill.type=='text' }">
          <ul class="checkbox_list margin-spacing-1_top">
            <li class="checkbox_list-item">
              <input
                class="checkbox-input js-check_skill-other"
                type="checkbox"
                checked="{ props.data.skill.isChecked(skill.id) }"
                id="skill_id_{ skill.id }"
                value="{ skill.id }"
                onclick="{ e => onCheckSkill(e, skill.id) }"
              />
              <label for="skill_id_{ skill.id }" class="checkbox-parts">
                { skill.jname }
              </label>
            </li>
          </ul>
          <div class="box_w50">
            <input
              class="text_input input_skill-other"
              type="text"
              value="{ props.data.skill.getMemo(skill.id) }"
              disabled="{ !props.data.skill.isChecked(skill.id) }"
              oninput="{ e => onTextSkill(e, skill.id) }"
            />
          </div>
          <div if="{ getError('skill', skill.id) }" class="error">
            { getError('skill', skill.id) }
          </div>
        </template>
      </template>
    </div>
    <!--/.accordion_body-->
  </div>
  <!--/.container_accordion-->

  <script>
    export default {
      onMounted(props, state) {
        for (const name of ["media", "contents", "skill"]) {
          if (props.data[name].isCheckedGroup()) {
            this.$(`[data-group="${name}"].accordion_heading`).classList.remove(
              "is-hide"
            );
            this.$(`[data-group="${name}"].accordion_body`).style.display =
              "block";
          }
        }
      },
      onCheckMediaAll(e) {
        let data = this.props.data;
        for (const type of this.props.master.media) {
          for (const detail of type.list) {
            for (const media of detail.list) {
              if (media.type == "check") {
                data.media.update({ id: media.id, checked: e.target.checked });
              }
            }
          }
        }
        this.props.onUpdate(data);
      },
      onCheckMediaType(e, id) {
        let data = this.props.data;
        for (const type of this.props.master.media) {
          if (type.id == id) {
            for (const detail of type.list) {
              for (const media of detail.list) {
                if (media.type == "check") {
                  data.media.update({
                    id: media.id,
                    checked: e.target.checked,
                  });
                }
              }
            }
          }
        }
        this.props.onUpdate(data);
      },
      onCheckMedia(e, id) {
        let data = this.props.data;
        data.media.update({ id, checked: e.target.checked });
        this.props.onUpdate(data);
      },
      onTextMedia(e, id) {
        let data = this.props.data;
        data.media.update({ id, memo: e.target.value });
        this.props.onUpdate(data);
      },

      onCheckContentsAll(e) {
        let data = this.props.data;
        for (const type of this.props.master.contents) {
          for (const contents of type.list) {
            if (contents.type == "check") {
              data.contents.update({
                id: contents.id,
                checked: e.target.checked,
              });
            }
          }
        }
        this.props.onUpdate(data);
      },
      onCheckContents(e, id) {
        let data = this.props.data;
        data.contents.update({ id, checked: e.target.checked });
        this.props.onUpdate(data);
      },
      onTextContents(e, id) {
        let data = this.props.data;
        data.contents.update({ id, memo: e.target.value });
        this.props.onUpdate(data);
      },

      onCheckSkillAll(e) {
        let data = this.props.data;
        for (const genre of this.props.master.skill) {
          for (const skill of genre.list) {
            if (skill.type == "check") {
              data.skill.update({
                id: skill.id,
                checked: e.target.checked,
              });
            }
          }
        }
        this.props.onUpdate(data);
      },
      onCheckSkill(e, id) {
        let data = this.props.data;
        data.skill.update({ id, checked: e.target.checked });
        this.props.onUpdate(data);
      },
      onTextSkill(e, id) {
        let data = this.props.data;
        data.skill.update({ id, memo: e.target.value });
        this.props.onUpdate(data);
      },
      getError(name, id) {
        return this.props.errors &&
          this.props.errors[name] &&
          this.props.errors[name][id]
          ? this.props.errors[name][id]
          : null;
      },
    };
  </script>
</skills>
